export const sliderArrowRight = () => {
  return (
    <svg
      width='13'
      height='20'
      viewBox='0 0 13 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0.831684 0.170434C0.209125 0.480617 -0.0755586 1.14574 0.125254 1.82083C0.198035 2.0656 0.316238 2.24171 0.574957 2.49087C0.768 2.6768 2.78609 4.41944 5.0597 6.36348C7.33332 8.30746 9.1919 9.91841 9.18997 9.94337C9.18805 9.96834 7.34766 11.5576 5.10028 13.4751C-0.0580274 17.8763 0.189801 17.6498 0.0623009 18.0786C-0.294965 19.2804 0.95354 20.3306 2.0424 19.7444C2.43374 19.5337 12.3281 11.0427 12.5553 10.7226C12.9755 10.1306 12.8903 9.42408 12.3334 8.88234C12.1587 8.71234 9.79978 6.67851 7.0914 4.36273C3.39716 1.20405 2.10137 0.132582 1.90401 0.0734802C1.50059 -0.0474456 1.21744 -0.0218123 0.831684 0.170434Z'
        fill='black'
      />
    </svg>
  );
};
